/**
 * Convierte una lista plana de nodos (id, parent, text, position, etc.) 
 * en una estructura anidada de árbol para componentes que lo requieran.
 */
export const buildNestedTree = (flatData) => {
  const map = {};
  const rootNodes = [];

  // Paso 1: Mapear todos los nodos por ID
  flatData.forEach(node => {
    map[node.id] = { ...node, children: [] };
  });

  // Paso 2: Construir la jerarquía
  flatData.forEach(node => {
    const parentId = node.parent;
    if (parentId === null || parentId === 0 || !map[parentId]) {
      rootNodes.push(map[node.id]);
    } else {
      map[parentId].children.push(map[node.id]);
    }
  });

  return rootNodes;
};
